export default __webpack_public_path__ + "static/media/bar-driver-behavior.058570cf.svg";